import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
//global variable
Vue.prototype.$axios = axios
Vue.prototype.serverurl = 'https://wafraapi.marketequityinc.com'
Vue.prototype.scripturl = 'https://wafraapi.marketequityinc.com/frontend/src/assets/'
   Vue.prototype.publicurl = 'https://wafraapi.marketequityinc.com/public/'

// Vue.prototype.$api_url = "http://127.0.0.1:8000/"
axios.defaults.baseURL = 'https://wafraapi.marketequityinc.com'

import VueI18n from 'vue-i18n';
Vue.prototype.asseturl='http://localhost'


Vue.use(VueI18n);

const messages = {
  en: {
    message: {
      value: 'This is an example of content translation.'
    }
  },
    العربية: {
    message: {
      value: 'العربية'
    }
  },
    中文: {
    message: {
      value: 'Dette er et eksempel på oversættelse af indhold.'
    }
  },
    Français: {
    message: {
      value: 'Ovo je primjer prevođenja sadržaja.'
    }
  }
   , Русский: {
    message: {
        value: 'Russian'
    }
}
};

const i18n = new VueI18n({
  locale: 'ar',
  messages
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  i18n
}).$mount('#app')
